<script>
  export let urls = [];
  export let fullUrls = [];
  export let onOpen;

  $: displayUrls = Array.isArray(urls) ? urls : [];
  $: galleryUrls = Array.isArray(fullUrls) && fullUrls.length ? fullUrls : displayUrls;
  $: visibleUrls = displayUrls.length > 6 ? displayUrls.slice(0, 6) : displayUrls;
  $: remainingCount = Math.max(0, displayUrls.length - 6);
  $: gridColumns = getGridColumns(displayUrls.length);

  function getGridColumns(count) {
    if (count <= 1) return 'one';
    if (count === 2) return 'two';
    return 'three';
  }

  function getTileClass(index) {
    if (displayUrls.length === 3 && index === 0) return 'tile tile--featured';
    if (displayUrls.length === 5 && index === 0) return 'tile tile--featured';
    return 'tile';
  }

  function openAlbum(index) {
    if (!galleryUrls.length) return;
    onOpen?.({ images: galleryUrls, index });
  }
</script>

{#if displayUrls.length}
  <div class={`album-grid album-grid--${gridColumns}`} aria-label="Album ảnh">
    {#each visibleUrls as url, index}
      <button
        type="button"
        class={getTileClass(index)}
        aria-label={`Xem ảnh ${index + 1}`}
        on:click|stopPropagation={() => openAlbum(index)}>
        <img src={url} alt={`Ảnh ${index + 1}`} loading="lazy" decoding="async" />

        {#if remainingCount > 0 && index === visibleUrls.length - 1}
          <span class="more-overlay">+{remainingCount}</span>
        {/if}
      </button>
    {/each}
  </div>
{/if}

<style>
  .album-grid {
    display: grid;
    gap: 0.25rem;
    width: min(20rem, 74vw);
    margin-top: 0.25rem;
  }

  .album-grid--one {
    grid-template-columns: minmax(0, 1fr);
    width: min(16rem, 68vw);
  }

  .album-grid--two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .album-grid--three {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .tile {
    appearance: none;
    position: relative;
    display: block;
    min-width: 0;
    padding: 0;
    overflow: hidden;
    border: 0;
    border-radius: 0.42rem;
    background: #e2e8f0;
    cursor: pointer;
    aspect-ratio: 1;
    -webkit-tap-highlight-color: transparent;
  }

  .tile--featured {
    grid-column: span 2;
    grid-row: span 2;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .more-overlay {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    color: #fff;
    background: rgba(15, 23, 42, 0.64);
    font-size: 1.05rem;
    font-weight: 800;
  }

  @media (max-width: 640px) {
    .album-grid {
      width: min(19rem, 78vw);
    }
  }
</style>
